import BulkCreatePolygonManager from "../../../views/BulkCreatePolygon";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkCreatePolygonManagerRoutes = [
  {
    menuName: MenuNames.BULK_UPSERT_POLYGON,
    path: "/bulk-create-polygon",
    component: BulkCreatePolygonManager,
    exact: true,
  },
];

export default BulkCreatePolygonManagerRoutes;